<template>
  <Modal :title="title" :showModal="showModal" class="edit-order-form large" @submit="submit">
    <template v-slot:body>
      <div class="d-flex align-items-start">
        <order :config="{ data, editable }"></order>
        <LineItems :config="{ data, editable }" v-model="data.line_items"></LineItems>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'
import Order from './Edit/Order.vue'
import LineItems from './Edit/LineItems.vue'
export default {
  mixins: [Event],
  components: {
    Order,
    LineItems
  },
  data() {
    return {
      /* prettier-ignore */
      submitStructure: [
        'flag',
        'delivery_info',
        'note',
        'line_items'
      ],
      data: {
        more: {
          flags: {}
        },
        delivery_info: {
          line: ['', '']
        },
        line_items: []
      }
    }
  },
  computed: {
    title() {
      return 'Edit Order'
    },
    action() {
      return 'edit'
    },
    storeId() {
      return this.config.storeId
    },
    orderId() {
      return this.config.data._id
    },
    getUri() {
      return `order/get/${this.orderId}`
    },
    submitUri() {
      return `order/update/${this.orderId}`
    },
    editable() {
      return {
        order: this.data.permission == 'edit',
        quantity: this.data.permission == 'edit'
      }
    }
  },
  methods: {
    setUpData(rawData) {
      if (rawData.status == 'success') {
        this.showModal = true
        this.data = Object.assign(this.data, rawData.data)
      }
    },
    submit() {
      this.submitForm(this.data, {
        done: () => {
          this.$emit('close')
          this.$emitter.emit('TableList.Refresh')
        }
      })
    }
  },
  props: {
    config: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>

<style lang="scss">
.modal.edit-order-form {
  .popup-wrap {
    width: 350px;
    min-width: 350px;
    padding-right: 30px;
  }
  .line-items {
    flex: 1;
  }
}
</style>
